import { IdTypes } from "@Network/request/api_combine_member_login";
import { useCallback, useEffect, useState } from "react";
import { TrackingContentTypeKey, TrackingScreenKey, TrackingShareMethodKey } from "./tracking_event_key";
import useTrackingStore from "./use_tracking_store";

const useTrackingManager = () => {
    const [trackingScreenKey, setTrackingScreenKey] = useState<TrackingScreenKey>();
    const [trackingScreenCategory, setTrackingScreenCategory] = useState<string | undefined>();

    //구독 시 타이밍에 따라 값이 갱신안될 수 있으므로 getstate를 사용해 최신값을 가져오기
    const { 
        setPageViewInfo,
        setBackupPageViewInfo,
        setPopupViewTitle,
        restorePageViewInfo
    } = useTrackingStore();

    //Screen 이벤트 관련 useEffect
    useEffect(() => {
        if(trackingScreenKey) {
            trackingPageViewEvent(trackingScreenKey, trackingScreenCategory)
        }

        // return () => {
            // console.log(`gaTag pop ${trackingScreenKey?.name}`);
            // if(trackingScreenKey) {
            //     console.log("gaTag pop1111");
            //     trackingPageViewEvent(trackingScreenKey, trackingCustomScreenName)
            // }
        // };
    }, [trackingScreenKey, trackingScreenCategory]);

    //State 값 변경에 따라 대응이 가능한 Screen 이벤트 함수
    const trackScreen = (
        screenKey:TrackingScreenKey,
        category?: string
    ) => {
        setTrackingScreenKey(screenKey);
        setTrackingScreenCategory(category);
    }

    //popup형태로 개발된 page인 경우
    const trackScreenPopup = (
        screenKey: TrackingScreenKey,
        category?: string
    ) => {
        trackingPageViewEvent(screenKey, category, true);
    }

    const trackScreenPopupClose = () => {
        // console.log(`gaTag trackScreenPopupClose page_id: ${useTrackingStore.getState().backupPageViewId} // page_title: ${useTrackingStore.getState().backupPageViewTitle} // page_category: ${""}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', 'page_view', {
                page_title: useTrackingStore.getState().backupPageViewId,
                page_id: useTrackingStore.getState().backupPageViewTitle,
                page_category: "",
                page_location: window.location.href,
                page_path: window.location.pathname
            });
            
            restorePageViewInfo();
        }
    };

    const trackingPageViewEvent = (
        screenKey: TrackingScreenKey,
        category?: string,
        isBackup:boolean = false,
    ) => {
        // console.log(`gaTag trackingPageViewEvent page_id: ${screenKey.id} // page_title: ${screenKey.name} // page_category: ${category ?? ""} // isBackup ${isBackup}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', 'page_view', {
                page_title: screenKey.name,
                page_id: screenKey.id,
                page_category: category ? category.replace(/\s+/g, "") : "",
                page_location: window.location.href,
                page_path: window.location.pathname
            });

            if(isBackup) {
                setBackupPageViewInfo(screenKey.id, screenKey.name.replace(/\s+/g, ""));
            } else {
                setPageViewInfo(screenKey.id, screenKey.name.replace(/\s+/g, ""));
            }
        }
    };

    const trackButtonClick = (
        name:string
    ) => {
        // console.log(`gaTag trackButtonClick page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // popup_title: ${useTrackingStore.getState().popupViewTitle} // button_name: ${name}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "button_click", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                popup_title: useTrackingStore.getState().popupViewTitle ?? "",
                button_name: name.replace(/\s+/g, ""),
            });
        }
    };

    const trackBannerClick = (
        creativeName:string,
        creativeImagePath:string,
        creativeSlot:string,
    ) => {
        const fileName = getImageFileName(creativeImagePath);
        // console.log(`gaTag trackBannerClick page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // popup_title: ${useTrackingStore.getState().popupViewTitle} // creative_name: ${creativeName} // creative_slot: ${creativeSlot} // ${fileName}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "banner_click", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                popup_title: useTrackingStore.getState().popupViewTitle ?? "",
                creative_name: `${creativeName.replace(/\s+/g, "")}_${fileName}`,
                creative_slot: creativeSlot.replace(/\s+/g, "")
            });
        }
    };

    const trackSelectContent = (
        contentType:TrackingContentTypeKey,
        itemId:string,
    ) => {
        // console.log(`gaTag trackSelectContent page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // contentType: ${contentType} // itemId: ${itemId}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "select_content", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                content_type: contentType,
                item_id: itemId.replace(/\s+/g, "")
            });
        }
    };

    const trackShareClick = (
        method:TrackingShareMethodKey,
        contentType:TrackingContentTypeKey,
        itemId:string,
    ) => {
        // console.log(`gaTag trackShareClick page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // method: ${method} // content_type: ${contentType} // item_id: ${itemId}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "share", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                method: method,
                content_type: contentType,
                item_id: itemId.replace(/\s+/g, "")
            });
        }
    }

    const trackLogin = (
        snsId: string,
    ) => {
        const idTypeRaw = snsId;
        const keys = Object.keys(IdTypes) as Array<keyof typeof IdTypes>;
        const sns = keys
          .filter((eachKey) => idTypeRaw === `${IdTypes[eachKey].sendableIdType}`)
          .at(0);

        // console.log(`gaTag trackLogin page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // method: ${sns}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "login", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                method: sns
            });
        }
    };

    const trackSignup = (
        snsId: string,
    ) => {
        const idTypeRaw = snsId;
        const keys = Object.keys(IdTypes) as Array<keyof typeof IdTypes>;
        const sns = keys
          .filter((eachKey) => idTypeRaw === `${IdTypes[eachKey].sendableIdType}`)
          .at(0);

        // console.log(`gaTag trackSignup page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // method: ${sns}`);
        const gTag = (window as any).gtag
        if(gTag) {
            gTag('event', "sign_up", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                method: sns
            });
        }
    }

    const trackPopup = (
        title: string
    ) => {
        const gTag = (window as any).gtag
        if(gTag) {
            const popupTitle = title.replace(/\s+/g, "")
            gTag('event', "popup", {
                page_title: useTrackingStore.getState().pageViewTitle ?? "",
                page_id: useTrackingStore.getState().pageViewId ?? "",
                popup_title: popupTitle ?? ""
            });
            // console.log(`gaTag trackPopup page_title: ${useTrackingStore.getState().pageViewTitle} // page_id: ${useTrackingStore.getState().pageViewId} // popup_title: ${popupTitle}`);
            setPopupViewTitle(popupTitle);
        }
    };

    const trackPopupClose = () => {
        // console.log(`gaTag trackPopupClose ${useTrackingStore.getState().popupViewTitle}`);
        setPopupViewTitle(undefined);
    }

    const getImageFileName = (name:string):string => {
        return (name.split('/').pop())?.split('.').shift() ?? "";
    }    

    return {
        trackScreen,
        trackScreenPopup,
        trackScreenPopupClose,
        trackButtonClick,
        trackBannerClick,
        trackSelectContent,
        trackShareClick,
        trackLogin,
        trackSignup,
        trackPopup,
        trackPopupClose,
        getImageFileName
    };
};

export default useTrackingManager;